// removed by extract-text-webpack-plugin
module.exports = {"checkbox-control":"checkbox--checkbox-control--KQEkRTMh","checkboxControl":"checkbox--checkbox-control--KQEkRTMh","is-checked":"checkbox--is-checked--hpH58BaJ","isChecked":"checkbox--is-checked--hpH58BaJ","checkbox":"checkbox--checkbox--2tFVRqKN","checkboxOverlay":"checkbox--checkboxOverlay--3R2tvxR3","label":"checkbox--label--3VBuiSTH","caption":"checkbox--caption--1iX_TiLj","hasError":"checkbox--hasError--2eEj-CIm"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Checkbox/checkbox.scss
// module id = 193
// module chunks = 0